import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CLeanupAdministrationRoutingModule } from './cleanup-administration-routing.module';
import { CleanuupAdministrationComponent } from './component/cleanup-administration.component';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  declarations: [
    CleanuupAdministrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CLeanupAdministrationRoutingModule,
    ServiceResponseModule,
    CommonTranslationModule
  ]
})
export class CleanupAdministrationModule { }
